<template>
  <v-app style="background-color: #f8f9fb">
    <v-container>
      <v-col cols="12">
        <v-card elevation="0" class="px-5 py-3">
          <v-row align="end">
            <v-col cols="12" sm="6" md="3">
              <span>&nbsp;</span>
              <v-btn
                color="#4682B4"
                block
                height="40"
                style="font-size: 14px; font-weight: bold"
                :loading="consultando"
                @click="consultarSaldo"
              >
                Consultar saldo
                <v-icon right dark>mdi-refresh</v-icon>
              </v-btn>
            </v-col>
            <v-col v-if="ultimaConsultaEm" cols="12" sm="6" md="9" class="text-right grey--text text--darken-1">
              Última consulta: {{ ultimaConsultaEm }}
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-container>

    <v-container style="background-color: #eee" fluid tag="section">
      <v-alert
        v-if="mensagem"
        :type="tipoMensagem"
        dense
        text
        class="mb-4"
        dismissible
        @input="mensagem = ''"
      >
        {{ mensagem }}
      </v-alert>

      <v-row v-if="saldoPrincipal !== null">
        <v-col cols="12" sm="6" md="4">
          <v-card class="pa-4 text-center saldo-card" elevation="2">
            <div class="saldo-label">Saldo disponível</div>
            <div class="saldo-valor">{{ formatarSaldo(saldoPrincipal) }}</div>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <base-material-card
            icon="mdi-cash-check"
            title="Saldo Lemit"
            color="rgb(71 130 180)"
            style="margin-top: 20px !important; padding-top: 10px !important"
            class="px-5 py-0"
          >
            <br />

            <div v-if="consultando && !saldo" class="text-center py-8">
              <v-progress-circular indeterminate color="primary" />
              <p class="mt-4 mb-0 grey--text">Consultando saldo na Lemit...</p>
            </div>

            <template v-else-if="saldo">
              <v-data-table
                v-if="linhasSaldo.length"
                :headers="headersSaldo"
                :items="linhasSaldo"
                :items-per-page="20"
                dense
                class="elevation-0 mb-4"
                hide-default-footer
              >
                <template v-slot:item.valor="{ item }">
                  {{ formatarValorCampo(item.valor) }}
                </template>
              </v-data-table>

              <div v-else class="section-title">Resposta completa</div>
              <pre v-if="!linhasSaldo.length" class="json-preview mb-4">{{ saldoFormatado }}</pre>
            </template>

            <div v-else class="text-center py-8 grey--text">
              Clique em <strong>Consultar saldo</strong> para buscar o crédito Lemit.
            </div>

            <br />
          </base-material-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import LemitService from '../../services/lemit'

const CHAVES_SALDO = [
  'saldo',
  'saldo_disponivel',
  'saldoDisponivel',
  'credito',
  'creditos',
  'balance',
  'disponivel',
  'valor',
]

export default {
  name: 'CentralConsultasSaldo',

  data() {
    return {
      consultando: false,
      mensagem: '',
      tipoMensagem: 'info',
      saldo: null,
      ultimaConsultaEm: '',
      headersSaldo: [
        { text: 'Campo', value: 'campo' },
        { text: 'Valor', value: 'valor' },
      ],
    }
  },

  computed: {
    linhasSaldo() {
      if (!this.saldo || typeof this.saldo !== 'object') return []
      return this.achatarObjeto(this.saldo)
    },

    saldoPrincipal() {
      return this.extrairSaldoPrincipal(this.saldo)
    },

    saldoFormatado() {
      if (this.saldo === null || this.saldo === undefined) return ''
      if (typeof this.saldo === 'string') return this.saldo
      return JSON.stringify(this.saldo, null, 2)
    },
  },

  mounted() {
    this.consultarSaldo()
  },

  methods: {
    extrairMensagemErro(error) {
      const data = error?.response?.data
      if (!data) return 'Não foi possível consultar o saldo Lemit. Tente novamente.'
      if (typeof data === 'string') return data
      return (
        data.mensagem ||
        data.mensagemErro ||
        data.message ||
        'Não foi possível consultar o saldo Lemit. Tente novamente.'
      )
    },

    extrairSaldoPrincipal(obj, profundidade = 0) {
      if (obj === null || obj === undefined || profundidade > 4) return null

      if (typeof obj === 'number') return obj

      if (typeof obj === 'string') {
        const numero = Number(String(obj).replace(/\./g, '').replace(',', '.'))
        return Number.isNaN(numero) ? null : numero
      }

      if (Array.isArray(obj)) {
        for (const item of obj) {
          const valor = this.extrairSaldoPrincipal(item, profundidade + 1)
          if (valor !== null) return valor
        }
        return null
      }

      if (typeof obj === 'object') {
        for (const chave of CHAVES_SALDO) {
          if (Object.prototype.hasOwnProperty.call(obj, chave)) {
            const valor = this.extrairSaldoPrincipal(obj[chave], profundidade + 1)
            if (valor !== null) return valor
          }
        }

        for (const chave of Object.keys(obj)) {
          if (CHAVES_SALDO.includes(chave)) continue
          const valor = this.extrairSaldoPrincipal(obj[chave], profundidade + 1)
          if (valor !== null) return valor
        }
      }

      return null
    },

    achatarObjeto(obj, prefixo = '') {
      if (obj === null || obj === undefined) {
        return [{ campo: prefixo || 'valor', valor: '—' }]
      }

      if (typeof obj !== 'object') {
        return [{ campo: prefixo || 'valor', valor: obj }]
      }

      if (Array.isArray(obj)) {
        return obj.flatMap((item, index) =>
          this.achatarObjeto(item, prefixo ? `${prefixo}[${index}]` : `[${index}]`)
        )
      }

      return Object.keys(obj).flatMap((chave) => {
        const caminho = prefixo ? `${prefixo}.${chave}` : chave
        const valor = obj[chave]

        if (valor !== null && typeof valor === 'object') {
          return this.achatarObjeto(valor, caminho)
        }

        return [{ campo: caminho, valor }]
      })
    },

    formatarSaldo(valor) {
      if (valor === null || valor === undefined) return '—'
      const numero = Number(valor)
      if (Number.isNaN(numero)) return String(valor)
      return numero.toLocaleString('pt-BR')
    },

    formatarValorCampo(valor) {
      if (valor === null || valor === undefined || valor === '') return '—'
      if (typeof valor === 'boolean') return valor ? 'Sim' : 'Não'
      if (typeof valor === 'number') return this.formatarSaldo(valor)
      if (typeof valor === 'object') return JSON.stringify(valor)
      return String(valor)
    },

    async consultarSaldo() {
      this.consultando = true
      this.mensagem = ''

      try {
        const response = await LemitService.saldo()
        this.saldo = response.data ?? null
        this.ultimaConsultaEm = new Date().toLocaleString('pt-BR')
        this.mensagem = 'Saldo consultado com sucesso.'
        this.tipoMensagem = 'success'
      } catch (error) {
        console.error('Erro ao consultar saldo Lemit:', error)
        this.saldo = null
        this.mensagem = this.extrairMensagemErro(error)
        this.tipoMensagem = 'error'
      } finally {
        this.consultando = false
      }
    },
  },
}
</script>

<style scoped>
.section-title {
  font-size: 15px;
  font-weight: 700;
  color: #355c7d;
  margin: 8px 0 10px;
}

.saldo-card {
  background: linear-gradient(135deg, #4682b4 0%, #355c7d 100%);
  color: #fff;
}

.saldo-label {
  font-size: 14px;
  opacity: 0.9;
  margin-bottom: 8px;
}

.saldo-valor {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.2;
}

.json-preview {
  background: #f5f5f5;
  border-radius: 4px;
  padding: 16px;
  overflow: auto;
  font-size: 13px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
